import * as api from "./client";

export type MeRole = {
  name: string;
  description: string;
};

export type Me = {
  sub: string;
  externalAuthId: string;
  userId: string | null;
  email: string;
  name: string;
  source: string;
  permissions: string[];
  firmFeatures: string[];
  organisationId: string | null;
  companyId: string | null;
  isImpersonating: boolean;
  impersonatedBy: string | null;
  iat: number;
  exp: number;
  status: "unverified" | "verified" | "rejected" | null;
  createdAt: string | null;
  updatedAt: string | null;
  roles: MeRole[];
};

export type GetMeResponse = {
  data: Me;
  request_id: string;
};

export async function fetchMe(): Promise<Me> {
  const response = await api.get<GetMeResponse>("/me");
  return response.data;
}
